angular.module("digitalLeasing.module")
  .component("checkListUploadLastMap", {
    templateUrl:
      "ng/components/digitalLeasing/contractSignature/checkListUploadLastMap/checkListUploadLastMap.view.html",
    bindings: {
      model: "=",
      checkListUpload: "&",
      uploadInProgess: "&",
      enableDisableSendArc: "&",
      checkSendArc: "<",
      snapshot: '<',
      portalRunned: "<"
    },
    controllerAs: "checkListUploadLastMapCtrl",
    controller: CheckListUploadLastMapController,
  });

function CheckListUploadLastMapController(
  FileUploader,
  $simulationService,
  $configService,
  $rootScope,
  $timeout,
  $modalService,
  $portalService,
  $financialApiService,
  $filter,
  $location,
  $download
) {
  var self = this;
  self.$portalService = $portalService;
  self.$onInit = function () {
    self.newGestVerbaleEnabled = $configService.getAppConfig().envData.newGestVerbaleEnabled;
    self.uploadDocumentSplit = false;
    self.listOfIdFileUploaded = [];
    self.listOfFilesError = [];
    self.listOfFilesUpload = [];
    self.listOfFilesUploadFromAru = [];
    self.visualProgBarDoc = [];
    self.listOfInfo = [];
    self.listOfInfoFromAru = [];
    if (getWizardMap(self.model.viewIndex) == "M17") {
      self.isLastMap = true;
      getPopulationCheckUploadListContract();
    } else {
      self.isLastMap = false;
      getFilesInfo();
    }

    self.loadingStatus = {
      uploading: false,
    };

    checkIfFileRequestIsUploaded();

    self.isAgentVendSolution = $configService.getAppConfig().user.type == 'VENDOR_AGENT' && $configService.getAppConfig().user.subType == 'LO_DIGITAL' ? true : false;
    self.validationObj = {
      documentDate: {
        disabledDays: [0],
        disabledDates: [
          "01-01",
          "06-01",
          "25-04",
          "01-05",
          "02-06",
          "15-08",
          "01-11",
          "08-12",
          "25-12",
          "26-12"
        ]
      },
      startDate: moment().subtract(30, 'days').format("DD/MM/YYYY"),
      endDate: moment().format("DD/MM/YYYY")
    };
  };

  self.$onChanges = function (changed) {
    if (
      changed.checkSendArc &&
      typeof changed.checkSendArc.currentValue != "undefined"
    ) {
      checkIfFileRequestIsUploaded();
    }
  };

  self.genericTrashCheck = function (index) {
    return (
      self.listOfFilesUpload[index] &&
      self.listOfFilesUpload[index].uploadedFiles &&
      self.listOfFilesUpload[index].uploadedFiles.some(function (element) {
        return element.isSelected == true;
      })
    );
  };

  self.downloadFile = function (file) {
    var input = {
      downloadKey: file.downloadKey
    }
    var url = "/uni/downloadDocDigital/service-infos/"
    $download.getGenericDownload(url, input)
      .then(function (response) {
        console.log(response)
      })
  }

  var getPopulationCheckUploadListContract = function () {
    self.waitFromRest = true;
    $simulationService
      .getChecklistUploadContract(self.model.leasingData.contratto, self.model.monitor)
      .then(function (response) {
        self.enableDisableSendArc({ value: response.success });
        if (response.additionalLabel == "LBL_USE_DIGITAL_SIGN_SECTION") {
          self.labelErrorCheckListCodificata = $filter("translate")("LBL_USE_DIGITAL_SIGN_SECTION").split("Firma Digitale");


        }
        self.labelErrorCheckList = response.additionalLabel;
        self.model.leasingData.contratto.documents.checklistUploadCdDocs =
          response.checklistUploadCdDocs;
        self.listOfFilesUpload = response.documents && response.documents;

        self.listOfFilesUpload.forEach(function (element) {
          element.linfaNomeDocumento = element.docNameLabel;
        });
        self.checkVenOwnerFile = self.listOfFilesUpload.some(function (
          element
        ) {
          return element.owner == "VEN";
        });

        //check if file is owner == cli

        self.checkCliOwnerFile = self.listOfFilesUpload.some(function (
          element
        ) {
          return element.owner == "CLI";
        });
        self.checkNotCliOwnerFile = self.listOfFilesUpload.some(function (
          element
        ) {
          return element.owner != "CLI";
        });
        self.chekIsVerbaleConsegna = self.listOfFilesUpload.some(function (
          element
        ) {
          return element.verbale == true;
        });
        self.chekIsGaranziaSubscribe = self.listOfFilesUpload.some(function (
          element
        ) {
          return !!element.garanzia;
        });

        self.checkStatusOfFile();
        self.waitFromRest = false;
        $timeout(function () {
          self.listOfFilesError.forEach(function (e) {
            jQuery('[title="' + e + '"]').addClass("text-red-important");
          });
        }, 2000);
        self.listOfFilesUpload.some(function (item) {
          if (item.owner === "VEN" || self.isAgentVendSolution) {
            self.enableVendorDocumentsSection = true;
          }
        });

        /* inizio */
        self.listOfFilesUpload.forEach(function (e) {
          e.uploadedFiles.forEach(function (h) {
            self.model.leasingData.contratto.documents.refused.forEach(
              function (x) {
                if (x == h.id) {
                  self.listOfFilesError.push(h.filename);
                  e.status = 2;
                }
              }
            );
          });
        });

        self.listOfFilesUpload.forEach(function (e, index) {
          e.uploadedFiles.forEach(function (h) {
            self.listOfIdFileUploaded.push(h.id);
          });
        });
        var testIfIdIsPresent = false;

        self.model.leasingData.contratto.documents.refused.forEach(function (
          e
        ) {
          self.listOfIdFileUploaded &&
            self.listOfIdFileUploaded.forEach(function (h) {
              if (e == h) {
                testIfIdIsPresent = testIfIdIsPresent || true;
              } else {
                testIfIdIsPresent = testIfIdIsPresent || false;
              }
            });
        });

        if (!testIfIdIsPresent) {
          self.model.leasingData.contratto.documents.corrected =
            self.model.leasingData.contratto.documents.refused;
          self.model.leasingData.contratto.documents.refused = [];
        }
        /* fine */
        checkIfFileRequestIsUploaded();
      })
      .catch(function (error) {
        console.log(error);
        self.waitFromRest = false;
        checkIfFileRequestIsUploaded();
      });
  };

  var getFilesInfo = function () {
    self.waitFromRest = true;
    $simulationService
      .populateUploadCheckList(self.model)
      .then(function (response) {
        self.model.leasingData.preventivo.documents.checklistUploadCdDocs =
          response.checklistUploadCdDocs;
        self.listOfFilesUpload = response.documents && response.documents;

        self.listOfFilesUpload.some(function (item) {
          if (item.owner === "VEN" || self.isAgentVendSolution) {
            self.enableVendorDocumentsSection = true;
          }
        });

        self.listOfFilesUpload.forEach(function (e) {
          e.uploadedFiles.forEach(function (h) {
            self.model.leasingData.preventivo.documents.refused.forEach(
              function (x) {
                if (x == h.id) {
                  self.listOfFilesError.push(h.filename);
                  e.status = 2;
                }
              }
            );
          });
        });

        self.listOfFilesUpload.forEach(function (e, index) {
          e.uploadedFiles.forEach(function (h) {
            self.listOfIdFileUploaded.push(h.id);
          });
        });
        var testIfIdIsPresent = false;

        self.model.leasingData.preventivo.documents.refused.forEach(function (
          e
        ) {
          self.listOfIdFileUploaded &&
            self.listOfIdFileUploaded.forEach(function (h) {
              if (e == h) {
                testIfIdIsPresent = testIfIdIsPresent || true;
              } else {
                testIfIdIsPresent = testIfIdIsPresent || false;
              }
            });
        });

        if (!testIfIdIsPresent) {
          self.model.leasingData.preventivo.documents.corrected =
            self.model.leasingData.preventivo.documents.refused;
          self.model.leasingData.preventivo.documents.refused = [];
        }
        self.checkStatusOfFile();
        self.waitFromRest = false;
        $timeout(function () {
          self.listOfFilesError.forEach(function (e) {
            jQuery('[title="' + e + '"]').addClass("text-red-important");
          });
        }, 2000);
        checkIfFileRequestIsUploaded();
      })
      .catch(function (error) {
        console.log("Error", error);
        self.waitFromRest = false;
        checkIfFileRequestIsUploaded();
      });
  };

  self.check = function (el) {
    el.isSelected = !el.isSelected;
  };

  // inizio procedura upload file
  self.uploader = new FileUploader({
    url: "",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
      "App-Name": $rootScope.portalName,
    },
  });

  self.uploadDataFunc = function (item, index) {
    var document =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (item) {
      self.uploadData = item;
    }
    self.uploadDocumenti = document;
    self.currentCodeTypeNameIndex = index;
    self.isSplit = arguments[4] && arguments[4];
    self.singleFile = self.listOfFilesUpload[index];
  };

  self.finalUpload = function () {
    console.log("calling finalUpload");
    self.folderPath = "" + new Date().getTime();
    if (!self.isSplit) {
      var url =
        $configService.getAppConfig().url +
        "/uni/upload/service-infos/" +
        encodeURIComponent(self.model.leasingData.preventivo.anno) +
        "/" +
        encodeURIComponent(self.model.leasingData.preventivo.numero) +
        "/FINANCIAL-" +
        self.singleFile.codiceDocNSIL;
    }
    self.disabledForUploadingInProgress = true;
    for (var int = 0; int < self.uploader.queue.length; int++) {
      self.uploader.queue[int].url = url;
    }
    self.loadingStatus.uploading = true;
    var filesUpload = document.querySelector(
      "#uploadInput_document_" + self.currentCodeTypeNameIndex
    ).files;
    filesUpload = Object.keys(filesUpload).map(function (key) {
      return filesUpload[key];
    });
    var formData = new FormData();

    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
    if (self.isSplit == "split") {
      var ndgCliente = self.isLastMap
        ? self.model.financialCustomer.metadata.riUserG.ndg
        : "";
      self.enableLoader = true;
      filesUpload.forEach(function (file) {
        formData = new FormData();

        appendToForm(formData, "file", file);
        appendToForm(formData, "type", "FINANCIAL");
        appendToForm(formData, "ndgCliente", ndgCliente);
        appendToForm(formData, "filename", file.name);
        appendToForm(formData, "idPratica", self.model.leasingData.id);
        appendToForm(formData, "numeroAnno", self.model.leasingData.preventivo.anno);
        appendToForm(formData, "numeroContratto", self.model.leasingData.contratto.numero);
        appendToForm(formData, "modulo", self.model.leasingData.contratto.modulo);
        appendToForm(formData, "numeroPreventivo", self.model.leasingData.preventivo.numero);

        $financialApiService
          .splitPdf(formData)
          .then(function (response) {
            response.forEach(function (elemResp) {
              var index = self.listOfFilesUpload.findIndex(function (element) {
                return element.cdDocNsil == elemResp.cdDocNsil;
              });
              if (index >= 0) {
                elemResp.uploadedFiles.forEach(function (elementToPush) {
                  self.listOfFilesUpload[index].status = 1;
                  self.listOfFilesUpload[index].uploadedFiles.push(
                    elementToPush
                  );
                });
              } else {
                if (elemResp.cdDocNsil != "GENP") {
                  self.listOfFilesUpload.push(elemResp);
                } else {
                  var temp = {
                    linfaNomeDocumento: elemResp.linfaNomeDocumento,
                    uploadedFiles: [],
                    cdDocNsil: elemResp.cdDocNsil,
                    status: 1,
                  };
                  self.listOfFilesUpload.push(temp);
                  elemResp.uploadedFiles.forEach(function (elementToPush) {
                    self.listOfFilesUpload[
                      self.listOfFilesUpload.length - 1
                    ].uploadedFiles.push(elementToPush);
                  });

                }
              }
            });
            self.disabledForUploadingInProgress = false;
            self.enableLoader = false;
            self.checkStatusOfFile();
            checkIfFileRequestIsUploaded();
          })
          .catch(function (error) {
            console.log(error);
            self.disabledForUploadingInProgress = false;
            self.enableLoader = false;
          });
      });
    } else {
      var ndgCliente = self.isLastMap
        ? self.model.financialCustomer.metadata.riUserG.ndg
        : self.singleFile.ndgCliente;
      if ((filesUpload.length + self.singleFile.uploadedFiles.length) > self.singleFile.maxUploadableFiles) {
        var partialDelete = (filesUpload.length + self.singleFile.uploadedFiles.length) - self.singleFile.maxUploadableFiles;
        var messages = "Siamo spiacenti ma per questo tipo di file è previsto il caricamento massimo di " + self.singleFile.maxUploadableFiles + " files."
        var elementDeleted = filesUpload.length - partialDelete;
        filesUpload.splice(elementDeleted);
        $rootScope.$broadcast("addAlert", {
          text: "UPLOAD_OVERRUN",
          message: messages
        });

      }
      filesUpload.forEach(function (file) {
        formData = new FormData();
        appendToForm(formData, "file", file);
        appendToForm(formData, "type", "FINANCIAL");
        appendToForm(formData, "ndgCliente", ndgCliente);
        appendToForm(formData, "filename", file.name);
        appendToForm(formData, "idPratica", self.model.leasingData.id);
        appendToForm(formData, "numeroAnno", self.model.leasingData.preventivo.anno);
        appendToForm(formData, "numeroContratto", self.model.leasingData.contratto.numero);
        appendToForm(formData, "modulo", self.model.leasingData.contratto.modulo);
        appendToForm(formData, "numeroPreventivo", self.model.leasingData.preventivo.numero);
        appendToForm(formData, "cdDoc", self.singleFile.cdDocNsil);
        appendToForm(formData, "idDocNsil", self.uploadDocumenti.idDocNsil);
        appendToForm(formData, "cfClient", self.model.financialCustomer.metadata.riUserG.cf);

        if (self.isLastMap) {
          appendToForm(formData, "checklistType", "CTR_LEASING");
          appendToForm(formData, "external", self.uploadDocumenti.external);

        }

        if (self.uploadDocumenti.owner != "VEN" && self.isLastMap) {
          appendToForm(formData, "digitale", self.model.leasingData.preventivo.firmaDigitale);
        }

        $financialApiService
          .uploadDocOnDigital(formData)
          .then(function (response) {
            if (response.success) {
              $timeout(function () {
                var tmp = {
                  filename: file.name,
                  id: response.id,
                  cdDoc: self.singleFile.cdDocNsil,
                  status: "1",
                  downloadKey: response.downloadKey
                };

                self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
                self.listOfFilesUpload[
                  self.currentCodeTypeNameIndex
                ].uploadedFiles.push(tmp);
                self.listOfFilesUpload[self.currentCodeTypeNameIndex].status =
                  "1";
                self.disabledForUploadingInProgress = false;
                self.uploadInProgess({
                  uploadInProgess: false,
                });
                if (
                  self.$portalService.isAru() &&
                  self.model.leasingData.preventivo.completatoArc
                ) {
                  self.model.leasingData.preventivo.documents.corrected.push(
                    parseInt(response.id)
                  );
                }
                self.checkStatusOfFile();
                checkIfFileRequestIsUploaded();
              }, 1);
            } else {
              self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
              self.disabledForUploadingInProgress = false;
            }
          })
          .catch(function (error) {
            checkIfFileRequestIsUploaded();
            self.disabledForUploadingInProgress = false;
            self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
          });
      });
    }
  };

  self.generateDownloadLink = function (file) {
    if (file.zipMode) {
      return (
        $configService.getUrl() +
        "/uni/downloadGenericDigital/service-infos/FINANCIAL/" +
        encodeURIComponent(file.cdDoc) +
        "/zip/" +
        encodeURIComponent(self.model.idWfInstance) +
        "/?token=" +
        $configService.getAppConfig().token
      );
    } else {
      return (
        $configService.getUrl() +
        "/uni/downloadDocDigital/service-infos/?downloadKey=" +
        encodeURIComponent(file.downloadKey) +
        "&token=" +
        $configService.getAppConfig().token
      );
    }
  };
  self.uploader.onWhenAddingFileFailed = function (item, filter, options) {
    console.info("onWhenAddingFileFailed", item, filter, options);
  };

  self.uploader.onAfterAddingFile = function (fileItem) {
    console.log("fileItem", fileItem);
    self.disabledForUploadingInProgress = true;
    self.progresso = 0;
    if (fileItem.file.size > 26214400) {
      $rootScope.$broadcast("addAlert", {
        text: "MAXIMUM_FILE_SIZE_EXCEEDED",
      });
      fileItem.remove();
      jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
    }
    var fileName = fileItem.file.name;
    //if ( ) {
    self.uploader.queue[0].progress = 100;

    self.visualProgBarDoc[self.currentCodeTypeNameIndex] = true;

    $timeout(function () {
      self.progresso = 100;
    }, 500);
    /*     } else {
          fileItem.remove();
          jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
          $rootScope.$broadcast("addAlert", {
            text: "FORMAT_NOT_SUPPORTED",
          });
          self.disabledForUploadingInProgress = false;
          self.uploadInProgess({
            uploadInProgess: false,
          });
        } */
  };

  self.uploader.onAfterAddingAll = function (addedFileItems) {
    console.info("onAfterAddingAll", addedFileItems);
    self.finalUpload(self.uploadData);
  };

  self.uploader.onBeforeUploadItem = function (item) {
    item.file.name = window.encodeURIComponent(item.file.name);
    item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
    self.disabledForUploadingInProgress = true;
    self.uploadInProgess({
      uploadInProgess: true,
    });
  };

  self.uploader.onProgressItem = function (fileItem, progress) {
    self.uploadCompleted = false;
  };

  self.uploader.onProgressAll = function (progress) { };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.loadingStatus.uploading = false;
  };

  self.uploader.onErrorItem = function (fileItem, response, status, headers) {
    console.info("onErrorItem", fileItem, response, status, headers);
    self.loadingStatus.uploading = false;
    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");

    $rootScope.$broadcast("addAlert", {
      text: "ERROR_UPLOADING_FILE",
    });

    self.disabledForUploadingInProgress = false;
    self.uploadInProgess({
      uploadInProgess: false,
    });
    $timeout(function () {
      self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
    }, 1);

    fileItem.remove();
    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
  };

  self.uploader.onCancelItem = function (fileItem, response, status, headers) {
    console.log(status);
  };

  self.uploader.onCompleteItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onCompleteItem", fileItem, response, status, headers);
    if (
      response &&
      response.uploadFileServicePojo &&
      response.uploadFileServicePojo.success
    ) {
      self.uploadOk = true;
      console.log(fileItem);

      var document = {
        fileStatus: null,
        isSelected: false,
        nameFile: response.uploadFileServicePojo.fileName,
        uuid: "",
        errorMessage: "",
        documentClass: "",
      };

      self.listOfFilesUpload = response.metadataUniUpload.uploadedfile.sort(
        function (a, b) {
          if (a.codiceDocNSIL > b.codiceDocNSIL) {
            return 1;
          } else {
            return -1;
          }
        }
      );
      self.checkStatusOfFile();
      checkIfFileRequestIsUploaded();
    }
    self.uploader.queue = [];

    $timeout(function () {
      self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;

      self.disabledForUploadingInProgress = false;
      self.uploadInProgess({
        uploadInProgess: false,
      });
    }, 1);
    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
  };

  self.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
    self.uploadCompleted = true;
  };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.uploading = false;
  };

  self.deletePrivacyDocument = function (index) {
    self.progresso = 100;

    self.visualProgBarDoc[index] = true;

    $timeout(function () {
      self.progresso = 0;
    }, 200);

    self.documentsToBeDeleted = self.listOfFilesUpload[
      index
    ].uploadedFiles.filter(function (elem) {
      return elem.isSelected == true;
    });

    var documentRow =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    self.documentsToBeDeleted.forEach(function (element) {
      var checklistType = undefined;
      if (self.isLastMap) {
        checklistType = "CTR_LEASING";
      }
      $simulationService
        .deleteChecklistFileDigital(element.id, checklistType)
        .then(function (response) {
          console.log(response);
          if (response.success) {
            $timeout(function () {
              self.visualProgBarDoc[index] = false;
              self.listOfFilesUpload[
                index
              ].uploadedFiles = self.listOfFilesUpload[
                index
              ].uploadedFiles.filter(function (e) {
                return e.isSelected != true;
              });
              if (self.listOfFilesUpload[index].uploadedFiles.length == 0) {
                self.listOfFilesUpload[index].status = "0";
              }
              self.model.leasingData.preventivo.documents.refused = self.model.leasingData.preventivo.documents.refused
                .filter(function (elem) {
                  return elem != element.id;
                }
                );
              self.uploadOk = false;
              self.checkStatusOfFile();
              checkIfFileRequestIsUploaded();
            }, 1);
          } else {
            self.visualProgBarDoc[index] = false;
            self.uploadOk = false;
            self.checkStatusOfFile();
            checkIfFileRequestIsUploaded();
          }
        })
        .catch(function (error) {
          console.log(error);
          self.checkStatusOfFile();
          checkIfFileRequestIsUploaded();
        });
    });
  };

  self.checkStatusOfFile = function () {
    self.listOfFilesUpload &&
      self.listOfFilesUpload.forEach(function (e, index) {
        var status = parseInt(e.status);

        var infoFiles = {
          icon: "",
          visualChek: true,
          visualTrash: true,
          status: 0,
        };
        if (!status) {
          infoFiles.icon = "icon-error text-red";
          infoFiles.visualTrash = true;
          infoFiles.status = 0;
          self.listOfInfo[index] = infoFiles;
          return;
        }

        switch (status) {
          case 1:
            infoFiles.icon = " icon-question-circle1 gray";
            infoFiles.visualTrash = true;
            infoFiles.status = 1;
            self.listOfInfo[index] = infoFiles;
            break;
          case 2:
            infoFiles.icon = "icon-exclamation-circle1 text-red";
            infoFiles.visualTrash = false;
            infoFiles.status = 2;
            self.listOfInfo[index] = infoFiles;
            break;
          case 3:
            infoFiles.icon = "icon-error text-red";
            infoFiles.visualTrash = false;
            infoFiles.status = 3;
            self.listOfInfo[index] = infoFiles;
            break;
          case 4:
            infoFiles.icon = "icon-flag1 green";
            infoFiles.visualTrash = false;
            infoFiles.status = 4;
            self.listOfInfo[index] = infoFiles;
            break;
          default:
            infoFiles.icon = "icon-error text-red";
            infoFiles.visualTrash = false;
            infoFiles.status = 0;
            self.listOfInfo[index] = infoFiles;
            break;
        }
      });
  };

  var checkIfFileRequestIsUploaded = function () {
    if (self.isLastMap) {
      if (
        self.model.leasingData.contratto.publishedArc &&
        self.$portalService.isAra()
      ) {
        var testpublishedArc =
          self.listOfFilesUpload &&
          self.listOfFilesUpload
            .filter(function (element) {
              return element.owner != "CLI";
            })
            .filter(function (element) {
              return element.mandatory == true;
            })
            .every(function (elem) {
              return elem.uploadedFiles.length > 0;
            });
        var testIfElementPresent =
          self.listOfFilesUpload &&
          self.listOfFilesUpload.filter(function (element) {
            return element.owner != "CLI" || (element.verbale && element.owner != 'VEN' && !element.garanzia);
          });
        if (testpublishedArc && testIfElementPresent.length) {
          self.checkListUpload({
            value: true,
          });
        } else {
          self.checkListUpload({
            value: false,
          });
        }
      } else if (
        !self.model.leasingData.contratto.publishedArc &&
        self.$portalService.isAra()
      ) {
        var testNotPublishedArc =
          self.listOfFilesUpload &&
          self.listOfFilesUpload
            .filter(function (element) {
              return element.mandatory == true;
            })
            .every(function (elem) {
              return elem.uploadedFiles.length > 0;
            });

        if (
          testNotPublishedArc &&
          self.listOfFilesUpload &&
          self.listOfFilesUpload.length
        ) {
          self.checkListUpload({
            value: true,
          });
        } else {
          self.checkListUpload({
            value: false,
          });
        }
      } else if (self.$portalService.isAru) {
        var contractToARC =
          self.listOfFilesUpload &&
          self.listOfFilesUpload
            .filter(function (element) {
              return element.owner == "CLI";
            })
            .filter(function (element) {
              return element.mandatory == true;
            })
            .every(function (elem) {
              return elem.uploadedFiles.length > 0;
            });
        var testIfElementPresent =
          self.listOfFilesUpload &&
          self.listOfFilesUpload.filter(function (element) {
            return element.owner == "CLI";
          });
        if (contractToARC && testIfElementPresent.length) {
          self.checkListUpload({
            value: true,
          });
        } else {
          self.checkListUpload({
            value: false,
          });
        }
      }
    } else {
      var test;

      if (self.$portalService.isAra() && (self.model.leasingData.preventivo.status == 'P300' || self.model.leasingData.preventivo.status == 'P325' || self.model.leasingData.preventivo.status == 'P350' || self.model.leasingData.preventivo.status == 'P425' || self.model.leasingData.preventivo.status == 'P415' || self.model.leasingData.preventivo.status == 'P450')) {

        test = self.listOfFilesUpload &&
          self.listOfFilesUpload
            .filter(function (element) {
              return element.mandatory == true && element.owner != "VEN";
            })
            .every(function (elem) {
              return elem.uploadedFiles.length > 0;
            });

      } else {
        test = self.listOfFilesUpload &&
          self.listOfFilesUpload
            .filter(function (element) {
              return element.mandatory == true;
            })
            .every(function (elem) {
              return elem.uploadedFiles.length > 0;
            });

      }


      var testGENP =
        self.listOfFilesUpload &&
        self.listOfFilesUpload
          .filter(function (element) {
            return element.cdDocNsil == "GENP";
          })
          .every(function (elem) {
            return elem.uploadedFiles.length > 0;
          });
      var listOfGENP =
        self.listOfFilesUpload &&
        self.listOfFilesUpload.filter(function (element) {
          return element.cdDocNsil == "GENP";
        });
      self.model.leasingData.preventivo.checklistDocumenti = self.listOfFilesUpload;
      if (
        (self.listOfFilesUpload && self.listOfFilesUpload.length && test) ||
        (listOfGENP && listOfGENP.length && testGENP)
      ) {
        self.checkListUpload({
          value: true,
        });
      } else {
        self.checkListUpload({
          value: false,
        });
      }
    }
  };

  self.marksAsWrong = function (index) {
    var selected = self.listOfFilesUpload[index].uploadedFiles.filter(function (
      element
    ) {
      return element.isSelected == true;
    });
    self.listOfFilesUpload[index].status = "2";
    self.model.leasingData.preventivo.documents.corrected = [];
    selected.forEach(function (e) {
      jQuery('[title="' + e.filename + '"]').addClass("text-red-important");
      e.isSelected = false;
      var check = self.model.leasingData.preventivo.documents.refused.find(
        function (ex) {
          return ex == e.id;
        }
      );
      if (!check) {
        self.model.leasingData.preventivo.documents.refused.push(e.id);
      }
    });

    self.checkStatusOfFile();
    checkIfFileRequestIsUploaded();
  };

  self.resetStato = function (index) {
    var selected = self.listOfFilesUpload[index].uploadedFiles;
    self.listOfFilesUpload[index].status = "1";
    selected.forEach(function (e) {
      jQuery('[title="' + e.filename + '"]').removeClass("text-red-important");
      e.isSelected = false;

      self.model.leasingData.preventivo.documents.refused = self.model.leasingData.preventivo.documents.refused.filter(
        function (element) {
          return element != e.id;
        }
      );
    });

    self.checkStatusOfFile();
    checkIfFileRequestIsUploaded();
  };
  self.openCloseUpload = function () {
    $(".dragandrophandler").slideToggle(1500);
    self.isOpen = !self.isOpen;
    $timeout(function () {
      var obj = jQuery("#dragandrophandlerLastMap");
      obj.on("dragenter", function (e) {
        e.stopPropagation();
        e.preventDefault();
        jQuery(this).css("border", "2px solid #0B85A1");
      });
      obj.on("dragover", function (e) {
        e.stopPropagation();
        e.preventDefault();
      });
      obj.on("drop", function (e) {
        jQuery(this).css("border", "2px dotted #0B85A1");
        e.preventDefault();
        var files = e.originalEvent.dataTransfer.files;
        //We need to send dropped files to Server
        handleFileUpload(files, obj);
      });
    }, 2000)
  }
  /* inizio */
  var handleFileUpload = function (files) {
    self.disabledForUploadingInProgress = true;
    self.enableLoader = true;
    var formData = new FormData();
    files = Object.keys(files).map(function (key) {
      return files[key];
    });
    var numOfIteration = files.length;
    self.spliInProgress = true;
    files.forEach(function (e) {
      formData = new FormData();
      appendToForm(formData, "file", e);
      appendToForm(formData, "type", "FINANCIAL");
      appendToForm(formData, "filename", e.name);
      appendToForm(formData, "idPratica", self.model.leasingData.id);
      appendToForm(formData, "numeroAnno", self.model.leasingData.preventivo.anno);
      appendToForm(formData, "numeroPreventivo", self.model.leasingData.preventivo.numero);
      $financialApiService
        .splitPdf(formData)
        .then(function (response) {
          numOfIteration--;
          response.forEach(function (elemResp) {
            var index = self.listOfFilesUpload.findIndex(function (element) {
              return element.cdDocNsil == elemResp.cdDocNsil;
            });
            if (index >= 0) {
              elemResp.uploadedFiles.forEach(function (elementToPush) {
                self.listOfFilesUpload[index].status = 1;
                self.listOfFilesUpload[index].uploadedFiles.push(elementToPush);
              });
            } else {
              if (elemResp.cdDocNsil != "GENP") {
                self.listOfFilesUpload.push(elemResp);
              } else {
                var temp = {
                  linfaNomeDocumento: "GENP",
                  uploadedFiles: [],
                  status: 1,
                };
                self.listOfFilesUpload.push(temp);
                elemResp.uploadedFiles.forEach(function (elementToPush) {
                  self.listOfFilesUpload[
                    self.listOfFilesUpload.length - 1
                  ].uploadedFiles.push(elementToPush);
                });

              }
            }
          });
          if (numOfIteration == 0) {
            self.enableLoader = false;
            self.spliInProgress = false;
            self.disabledForUploadingInProgress = false;
          }
          self.checkStatusOfFile();
          checkIfFileRequestIsUploaded();
        })
        .catch(function (error) {
          console.log(error);
          self.disabledForUploadingInProgress = false;
          self.enableLoader = false;
        });
    });
  };
  /* fine */
  var getWizardMap = function (viewIndex) {
    return $rootScope.wizardMap.find(function (element) {
      return element.index == viewIndex;
    }).viewName;
  };

  self.goToDigitalSing = function () {
    $location.path("/firmaDigitale");

  }

  self.openModalVerbale = (index, file) => {
    $modalService.openModal("verbaleConsegna-modal")
    self.temporaneyIndex = index;
    self.temporaneyFile = file;

  }

  self.setDate = (name, valueDate) => {
    self.temporaneyFile.dataConsegna = valueDate
  }

  self.closeModal = () => {
    $modalService.closeModal("verbaleConsegna-modal");
  }

  self.saveInfoVerbale = () => {
    self.enableLoaderModal = true;
    $simulationService.saveVerbale(self.temporaneyFile.ordine, self.temporaneyFile.dataConsegna)
      .then((response) => {
        if (response.success) {
          $modalService.closeModal("verbaleConsegna-modal");
        }
        self.enableLoaderModal = false;
      })
      .catch((error) => {
        console.log(error);
        self.enableLoaderModal = false;
      })

  }

  self.enableButtonModa = () => {

    return !!self.temporaneyFile &&
      ((self.newGestVerbaleEnabled && !!self.temporaneyFile.dataConsegna) || !self.newGestVerbaleEnabled) &&
      !!self.temporaneyFile.uploadedFiles &&
      !!self.temporaneyFile.uploadedFiles.length

  }
}